import { type HTMLInputTypeAttribute } from 'react';
import parsePhoneNumber, { type CountryCode } from 'libphonenumber-js';

import { isolateNumbers } from 'widget/actions';

const getEmoji = (countryCode: CountryCode) => {
  const codePoints = countryCode
    .toUpperCase()
    .split('')
    .map(char => 0x1f1e6 + char.charCodeAt(0) - 65);

  const emoji = String.fromCodePoint(...codePoints);
  return emoji;
};

const getFlag = (
  value: string,
  type: HTMLInputTypeAttribute,
): string | null => {
  if (type != 'tel') return null;

  const numbers = isolateNumbers(value);
  if (!numbers) return null;

  const parsed = parsePhoneNumber(`+${numbers}`);
  if (!parsed?.country) return null;

  const emoji = getEmoji(parsed.country);
  return emoji;
};

export { getFlag };
